import React from 'react';
import { Row, Col, Card, Typography, Space } from 'antd';
import ByLeadersBarChart from '../../graphics/byLeadersBarChart';
import { formatVisiblePercent, getEvaluationScoreColor } from '../selfcare360/selfcare360Scales';

const { Text } = Typography;

const getPersonKey = (person) => [
    person?.id,
    person?.uuid,
    person?.email,
    `${person?.first_name || ''}-${person?.last_name || ''}`,
    `${person?.first_name || ''}-${person?.last_name || ''}-${person?.average ?? ''}`,
].find((value) => value !== undefined && value !== null && value !== '');

const mergeUniquePeople = (...groups) => {
    const seen = new Set();

    return groups.flat().filter((person) => {
        const key = getPersonKey(person);
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    });
};

const LeadershipByLeaders = ({ data, globalAverage, title, redLight, yellowLight, serviceId }) => {
    const sortedByAverage = [...data].sort((a, b) => b.average - a.average);
    const bestFive = sortedByAverage.slice(0, 5);
    const worstFive = sortedByAverage.slice(-5);
    const dimensions = mergeUniquePeople(bestFive, worstFive);
    const top2 = bestFive.slice(0, 2);
    const bottom2 = worstFive.slice(-2);

    const getContrastTextColor = (bgColor) =>
        String(bgColor).toLowerCase() === '#fbc02d' ? '#000' : '#fff';

    const globalBgColor = getEvaluationScoreColor(globalAverage, { redLight, yellowLight, serviceId });
    const globalTextColor = getContrastTextColor(globalBgColor);

    const renderLeadersSummary = (top2, bottom2) => {
        const formatWithAverage = (p) => `${p.first_name} ${p.last_name} (${formatVisiblePercent(p.average)})`;

        const bestList = top2.map(formatWithAverage);
        const worstList = bottom2.map(formatWithAverage);

        return (
            <Text style={{ fontSize: '16px', lineHeight: 1.8, textAlign: 'justify' }}>
                Los líderes que obtuvieron mejores resultados fueron{" "}
                <Text strong>{bestList.join(", ")}</Text>. <br />
                Los líderes con los resultados más bajos fueron{" "}
                <Text strong>{worstList.join(", ")}</Text>.
            </Text>
        );
    };

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Row gutter={[16, 16]} align="stretch">
                {/* Análisis centrado */}
                <Col xs={24} md={16}>
                    <Card bordered style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                        {renderLeadersSummary(top2, bottom2)}
                    </Card>
                </Col>
                <Col xs={24} md={8} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Card
                        style={{
                            backgroundColor: globalBgColor,
                            textAlign: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: "100%",
                            width: "100%"
                        }}
                    >
                        <Text style={{ color: globalTextColor, fontSize: 16, marginBottom: 10, fontWeight: "bold" }}>Global Compañía</Text>
                        <br></br>
                        <Text style={{ color: globalTextColor, fontSize: 32, fontWeight: "bold" }}>{formatVisiblePercent(globalAverage)}</Text>
                    </Card>
                </Col>
            </Row>
            {/* Gráfico y promedio global */}
            <Row gutter={[16, 16]}>
                <Col xs={24} md={24}>
                    <ByLeadersBarChart data={dimensions} redLight={redLight} yellowLight={yellowLight} serviceId={serviceId} />
                </Col>
            </Row>
        </Space>
    );
};

export default LeadershipByLeaders;
